import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/about_us/erweima22.png'


const _hoisted_1 = { class: "about-us" }
const _hoisted_2 = { class: "about-us-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "company-profile" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { style: {"width":"100%","max-width":"1200rem","margin":"0 auto","text-align":"start"} }
const _hoisted_7 = {
  key: 0,
  class: "breadcrumb"
}
const _hoisted_8 = { class: "breadcrumb-current" }
const _hoisted_9 = {
  key: 0,
  class: "job-cards-container"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "job-title" }
const _hoisted_12 = { class: "job-responsibilities" }
const _hoisted_13 = {
  key: 1,
  class: "job-detail-container"
}
const _hoisted_14 = { class: "job-detail-content" }
const _hoisted_15 = { class: "job-detail-section" }
const _hoisted_16 = { class: "job-detail-responsibilities" }
const _hoisted_17 = { class: "job-detail-section" }
const _hoisted_18 = { class: "contact-methods" }
const _hoisted_19 = { class: "contact-method" }
const _hoisted_20 = { class: "contact-value" }
const _hoisted_21 = {
  key: 2,
  class: "ryzz honor"
}
const _hoisted_22 = { class: "ryzz-list" }
const _hoisted_23 = { class: "ryzz-viewport" }
const _hoisted_24 = { class: "honors-card" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "honors-text" }
const _hoisted_27 = {
  key: 3,
  class: "xwzx"
}
const _hoisted_28 = { class: "xwzx-box" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "news-content" }
const _hoisted_31 = ["onClick"]

import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { selectCommonElement, addConsult } from '@/api'
import router from '@/router';
import store from '@/store';
import { useRoute } from 'vue-router';
import { ElCarousel, ElCarouselItem } from 'element-plus'
// import ContactUs from '@/components/ContactUs.vue';
import { asynchronousRetrieval } from '@/utils'

export default /*@__PURE__*/_defineComponent({
  __name: 'AboutUsView',
  setup(__props) {

const route = useRoute();
const loadUrl: any = ref({})
const currentPageType = ref(7) // 7: 公司介绍, 8: 加入我们
const currentJobView = ref('list') // 'list': 卡片列表, 'detail': 职位详情
const selectedJobIndex = ref(0) // 当前选中的职位索引

// 招聘岗位数据
const jobList = ref([
  {
    title: '算法工程师（图像识别方向）',
    responsibilities: [
      '负责图像识别算法研发部署，优化模型适配端侧，协作封装SDK，跟踪前沿技术迭代。',
      '主导图像识别算法开发，轻量化模型保帧率，压缩优化适配设备，协作攻坚提性能。'
    ],
    detailResponsibilities: [
      '主导微信小程序插件中图像识别算法的研发与部署，覆盖平面识别、人脸识别、2D标记识别、图片分类、手势识别、身体姿态估计等核心功能，替代微信原生API并提升性能与精度。',
      '设计轻量化深度学习模型（如MobileNet、YOLO变体），适配小程序端运行环境（WebAssembly/微信原生框架），实现高帧率（≥30fps）实时推理。',
      '构建多任务学习框架，优化多模态识别协同（如平面检测与人脸识别联合推理），降低计算冗余与内存占用。',
      '开发数据增强与合成技术，针对小程序场景优化数据集（如复杂光照、遮挡、低分辨率图像），提升算法鲁棒性。',
      '与前端团队协作完成算法集成，封装高效SDK接口，解决模型部署中的性能瓶颈（如JS与Native代码通信延迟）。',
      '探索模型量化（INT8/FP16）、剪枝、蒸馏等压缩技术，将模型体积控制在5MB以内，适配低端机型CPU/GPU/NPU异构计算。',
      '跟踪前沿技术（如Vision Transformer、神经架构搜索），推动算法在识别准确率与效率上的持续迭代。'
    ],
    contactMethod: {
      email: 'hrm@nfznxr.com',
    }
  },
  {
    title: '算法工程师（SLAM方向）',
    responsibilities: [
      '负责AR增强现实相关的重建、定位、跟踪等核心算法开发和优化；',
      '研发AR重建定位算法，优化多模态数据融合，解决跨平台性能问题，协作打造AR/VSLAM产品方案。'
    ],
    detailResponsibilities: [
      '负责AR增强现实相关的重建、定位、跟踪等核心算法开发和优化。',
      '负责AR/VSLAM系统的核心算法设计、实现与优化，包括特征提取、特征匹配、位姿估计、闭环检测、地图构建等模块。',
      '提升算法在复杂场景下的鲁棒性（如低纹理、动态物体、光照变化等）和实时性。',
      '结合IMU、RGB-D相机、LiDAR、ToF等多模态传感器数据，优化VSLAM系统的精度和稳定性。',
      '将算法移植到移动端（iOS/Android）、AR眼镜、机器人或嵌入式平台，解决性能优化（如内存、算力、功耗）问题。',
       '跟踪学术界与工业界最新进展（如神经辐射场NeRF、语义SLAM、端到端SLAM等），推动技术落地。',
       '与3D渲染、计算机视觉、硬件团队合作，打造完整的AR/VSLAM产品解决方案。'
    ],
    contactMethod: {
      email: 'hrm@nfznxr.com',
    }
  },
  {
    title: '前端开发工程师',
    responsibilities: [
      '负责AR小程序插件开发，基于Vue/WebGL构建3D渲染组件，优化性能与数据通信，协作算法移植并输出技术文档。',
      '开发AR小程序框架与3D渲染模块，解决性能瓶颈，协作算法移植，编写规范助力客户端集成。'
    ],
    detailResponsibilities: [
      '负责AR小程序插件的基础框架设计与开发，基于Vue技术栈实现可视化组件的模块化设计与功能扩展。',
      '开发基于WebGL/Three.js的高性能3D渲染组件库，构建浏览器端AR场景交互与虚实融合解决方案。',
      '开发基于WebGL/WebAssembly的高性能3D渲染模块，支持实时SLAM建图、AR场景交互及虚实融合效果。',
      '优化B/S架构下的三维数据通信机制，设计前后端分离的数据加载与渲染策略。',
      '解决小程序平台的性能瓶颈（如内存管理、多线程渲染、实时数据同步），保障SLAM算法的流畅运行。',
      '与算法团队协作，完成SLAM算法的前端移植、数据通信及可视化调试。',
      '编写技术文档，输出插件开发规范及接入指南，支持客户端的快速集成与问题排查。',
    ],
    contactMethod: {
      email: 'hrm@nfznxr.com',
    }
  },
  {
    title: '产品经理',
    responsibilities: [
      '负责产品全生命周期管理，挖掘需求、输出方案。',
      '协调团队推进开发，跟踪数据与反馈，优化产品并提交分析报告。'
    ],
    detailResponsibilities: [
      '负责产品全生命周期管理，包括需求挖掘、规划设计与迭代优化，确保产品满足用户与业务目标。',
      '负责与客户、业务方沟通需求，输出产品 PRD、原型图，制定产品 roadmap 及版本迭代时间表。',
      '负责协调研发、设计、测试等团队，跟进产品开发进度，及时发现并解决项目推进中的问题。',
      '监控产品上线后的运营数据与用户反馈，分析用户行为，提出产品优化方案并推动落地。',
      '配合团队建立规范的产品管理流程，包括需求评审、版本规划、上线验收等，监督流程执行。',
      '对产品市场表现、用户满意度进行跟踪评估，开展竞品分析，输出产品优化与迭代建议。',
      '定期提交产品分析报告，反馈产品进度、数据表现及待优化问题，形成书面总结与改进计划。',
    ],
    contactMethod: {
      email: 'hrm@nfznxr.com',
    }
  },
  {
    title: '销售经理',
    responsibilities: [
      '针对元宇宙行业，寻找目标B端客户。',
      '掌握公司产品的优势及操作，为客户做产品演示，借助公司产品为客户提供解决方案。'
    ],
    detailResponsibilities: [
      '针对元宇宙行业，寻找目标客户（B端）。',
      '约访客户，面谈沟通，分析客户需求及痛点，为客户提供专业的解决方案。',
      '熟练掌握公司SaaS产品的优势及操作，能为客户做产品演示，借助公司产品为客户提供SaaS系统的解决方案，实现签约。',
      '配合产品售前售后支持人员完成客户系统搭建。',
      '大专及以上学历，有软件销售工作优先。',
      '对销售工作主动热情，有目标感。',
      '有良好的客户意识，思维敏捷，具有较强的说服力及团队合作精神。',
      '追求更高工资、有长远发展的动力。',
      '能扛压，愿意与公司共同成长。',
      '能接受出差。',
    ],
    contactMethod: {
      email: 'hrm@nfznxr.com',
    }
  }
])

let timer3: any = null;
const newsList: any = ref([])
const honors = [
  {
    url: require('@/assets/images/about_us/ryzz8.jpg'),
    illustrate: ['高新技术企业']
  },
  {
    url: require('@/assets/images/about_us/ryzz1.png'),
    illustrate: ['2023上海最具投资潜力', '50佳创业企业']
  },
  {
    url: require('@/assets/images/about_us/ryzz2.png'),
    illustrate: ['“创客中国”元宇宙（人工智能）', '专业赛 一等奖']
  },
  {
    url: require('@/assets/images/about_us/ryzz3.png'),
    illustrate: ['2023数智创新优胜奖']
  },
  {
    url: require('@/assets/images/about_us/ryzz6.png'),
    illustrate: ['2024年度典型案例']
  },
  {
    url: require('@/assets/images/about_us/ryzz7.png'),
    illustrate: ['上海市创新创业大赛 优胜奖']
  },
]

const activeNewsIndex = ref(0)
const contactInfo: any = reactive({
  companyName: '',
  name: '',
  phone: '',
  industry: null
})
const showCustomerState = ref(0)
const industryList = [
  {
    name: '文娱',
    value: 1,
  },
  {
    name: '工业',
    value: 2,
  },
  {
    name: '教育',
    value: 3,
  },
  {
    name: '其他',
    value: 4,
  }
]
const showError = ref(false)
const checkEmpty: any = ref({})

const submitEvent = () => {
  let reg = /^(130|131|132|133|134|135|136|137|138|139|145|146|147|148|149|150|151|152|153|155|156|157|158|159|166|170|171|173|174|175|176|177|178|180|181|182|183|184|185|186|187|188|189|191|198|199)\d{8}$/
  Object.keys(contactInfo).forEach((k) => {
    checkEmpty.value[k] = !contactInfo[k]
  })
  if (!reg.test(contactInfo.phone.replace(/\s+/g, "")) || !contactInfo.phone) {
    showError.value = true;
    return
  } else if (!contactInfo.companyName || !contactInfo.name || !contactInfo.industry) {
    return
  }
  addConsult({ ...contactInfo }).then((res: any) => {
    showCustomerState.value = 2;
    contactInfo.companyName = ''
    contactInfo.name = ''
    contactInfo.phone = ''
    contactInfo.industry = null
    showError.value = false;
    checkEmpty.value = {}
  })
}

const changeState = (val: number) => {
  showCustomerState.value = val;
}


const toOtherPath = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
  store.state.pageTitleStr = `新闻中心 / 新闻详情 / ${title}`
}

// 点击招聘卡片，显示详情页面
const showJobDetail = (index: number) => {
  selectedJobIndex.value = index;
  currentJobView.value = 'detail';
}

// 返回卡片列表页面
const backToJobList = () => {
  currentJobView.value = 'list';
}

onMounted(async () => {
  // 处理路由参数
  const type = route.query.type;
  if (type && +type === 8) {
    currentPageType.value = 8; // 加入我们
  } else {
    currentPageType.value = 7; // 公司介绍
  }

  selectCommonElement({ columnId: 5, appId: 2 }).then((res: any) => {
    newsList.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0)).slice(0, 4).map((e: any) => {
      const date = new Date(e.newsTimestamp || e.createTime)
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      e.times = `${y}-${m}-${d}`
      return e;
    })
  })

  clearInterval(timer3)
  timer3 = setInterval(() => {
    activeNewsIndex.value += 1;
    if (activeNewsIndex.value > 3) {
      activeNewsIndex.value = 0;
    }
  }, 3000)

  const particle_moment_mp4: any = await asynchronousRetrieval('webimg/images/home/particles-moment.mp4');
  const banner_bg: any = await asynchronousRetrieval('webimg/images/about_us/banner-bg.png');
  const company_profile: any = await asynchronousRetrieval('webimg/images/about_us/company-profile.png');
  loadUrl.value = { particle_moment_mp4, banner_bg, company_profile }
})

onUnmounted(() => {
  clearInterval(timer3)
})

// 监听路由变化
watch(() => route.query.type, (newType) => {
  if (newType && +newType === 8) {
    currentPageType.value = 8; // 加入我们
    // 重置职位详情页面状态
    currentJobView.value = 'list';
  } else {
    currentPageType.value = 7; // 公司介绍
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: currentPageType.value === 8 ? require('@/assets/images/about_us/jiaruwomen.png') : loadUrl.value.banner_bg
      }, null, 8, _hoisted_3),
      _createElementVNode("div", null, _toDisplayString(currentPageType.value === 8 ? '火热招聘' : '关于我们'), 1)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["about-us-content", currentPageType.value === 8 ? 'job-content' : ''])
    }, [
      (currentPageType.value === 7)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "introduce" }, [
              _createElementVNode("div", null, "公司介绍"),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, "混空是一家专注元宇宙数实融合场景建设的公司，深耕XR+AI技术突破，为文娱、商业、工业、教育行业提供综合解决方案。"),
                _createElementVNode("div", null, "混空自研多项核心底层技术，专注于视觉+AI算法融合，实现厘米级空间定位。核心产品混空 Studio（智能体）是一款AI+AR元宇宙内容创作与分发平台，帮助用户一站式完成空间数字化建模和元宇宙互动营销场景创作，并通过XR眼镜、手机等实现跨端数实融合体验。"),
                _createElementVNode("div", null, "公司获得国家级高新技术企业认定、国家双软企业认定和国家科技型中小企业认定，已申请70多项知识产权，并凭借数实融合技术多次斩获国内投资价值类奖项，成为元宇宙头部公司。")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: loadUrl.value.company_profile
              }, null, 8, _hoisted_5)
            ])
          ], 64))
        : (currentPageType.value === 8)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_6, [
                (currentJobView.value === 'detail')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("span", {
                        onClick: backToJobList,
                        class: "breadcrumb-link"
                      }, "加入我们"),
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "breadcrumb-separator" }, " > ", -1)),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(jobList.value[selectedJobIndex.value].title), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (currentJobView.value === 'list')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobList.value, (job, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "job-card",
                        key: index,
                        onClick: ($event: any) => (showJobDetail(index))
                      }, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(job.title), 1),
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "job-subtitle" }, "【岗位职责】", -1)),
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(job.responsibilities, (responsibility, idx) => {
                            return (_openBlock(), _createElementBlock("div", { key: idx }, _toDisplayString(idx + 1) + ". " + _toDisplayString(responsibility), 1))
                          }), 128))
                        ])
                      ], 8, _hoisted_10))
                    }), 128))
                  ]))
                : (currentJobView.value === 'detail')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "job-detail-subtitle" }, "【岗位职责】", -1)),
                          _createElementVNode("div", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobList.value[selectedJobIndex.value].detailResponsibilities, (responsibility, idx) => {
                              return (_openBlock(), _createElementBlock("div", { key: idx }, _toDisplayString(idx + 1) + ". " + _toDisplayString(responsibility), 1))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "job-detail-subtitle" }, "【投递方式】", -1)),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "contact-label" }, "邮箱投递：", -1)),
                              _createElementVNode("div", _hoisted_20, _toDisplayString(jobList.value[selectedJobIndex.value].contactMethod.email), 1)
                            ]),
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "contact-method" }, [
                              _createElementVNode("div", { class: "contact-label" }, "微信投递："),
                              _createElementVNode("div", { class: "contact-qr" }, [
                                _createElementVNode("img", {
                                  src: _imports_0,
                                  style: {"width":"160rem","height":"160rem"}
                                })
                              ])
                            ], -1))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
      (currentPageType.value === 7)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title" }, "荣誉资质", -1)),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_unref(ElCarousel), {
                  interval: 3000,
                  type: "card",
                  height: "400rem",
                  arrow: "hover",
                  "indicator-position": 'none'
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(honors, (item, index) => {
                      return _createVNode(_unref(ElCarouselItem), { key: index }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("img", {
                              src: item.url
                            }, null, 8, _hoisted_25),
                            _createElementVNode("div", _hoisted_26, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.illustrate, (e, i) => {
                                return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(e), 1))
                              }), 128))
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    }), 64))
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (currentPageType.value === 7)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title-font-style title" }, "公司动态", -1)),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toOtherPath(newsList.value[activeNewsIndex.value].relatedHtmlId, newsList.value[activeNewsIndex.value].title)))
              }, [
                (newsList.value[activeNewsIndex.value])
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: newsList.value[activeNewsIndex.value].ossPath || ''
                    }, null, 8, _hoisted_29))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, (e, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      onClick: ($event: any) => (toOtherPath(e.relatedHtmlId, e.title)),
                      class: _normalizeClass(activeNewsIndex.value == i ? 'active' : '')
                    }, [
                      _createElementVNode("div", null, _toDisplayString(e.title), 1),
                      _createElementVNode("div", null, _toDisplayString(e.times), 1)
                    ], 10, _hoisted_31))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})